module.exports = __webpack_public_path__ + "static/main1-en-51af92c6e0a779bd90b353cb1a07765e.png";